import React from 'react';
import { FormattedMessage } from 'react-intl';
import FontAwesome from 'react-fontawesome';
import { Alert } from 'react-bootstrap';
import defaultMsg from '../../../translations/lang/en-US.json';

export default class PasswordSuccess extends React.Component {
	render() {
		return (
			<div className="password-reset-success">
				<h4 className="modal-title olo-client-theme-color text-center">
					<FormattedMessage
						id="resetPasswordSuccess"
						defaultMessage={defaultMsg.resetPasswordSuccess}
					/>
				</h4>
				<div className="font-medium login-help-block text-center">
					<Alert bsStyle="success">
						<FontAwesome name="check" className="text-success" />
						{'  '}
						<FormattedMessage
							id="resetPasswordSuccessAlert"
							defaultMessage={defaultMsg.resetPasswordSuccessAlert}
						/>
						<br />
						<a href={`/${this.props.lavuToGoName}`}>
							<FormattedMessage
								id="returnToMenu"
								defaultMessage={defaultMsg.returnToMenu}
							/>
						</a>
					</Alert>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/auth/passwordreset/PasswordSuccess.jsx